import { render, staticRenderFns } from "./TypingRecord.vue?vue&type=template&id=23cfcbc0&scoped=true&"
import script from "./TypingRecord.vue?vue&type=script&lang=js&"
export * from "./TypingRecord.vue?vue&type=script&lang=js&"
import style0 from "./TypingRecord.vue?vue&type=style&index=0&id=23cfcbc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfcbc0",
  null
  
)

export default component.exports